export default [
    {name: 'New', id: 0},
    {name: 'Qualified', id: 1},
    {name: 'Discussion', id: 2},
    {name: 'Negotiation', id: 3},
    {name: 'Won', id: 4},
    {name: 'Lost', id: 5}
];
